export default function (rate, rateTypes) {
    const validators = rateTypes.find(type => type.value === rate.type).validators;
    let isValidate = true;
    for (const validator of validators) {
        const data = rate[validator.name];
        if (data) {
            isValidate = isValidate && validator.check(data);
        }
        else {
            return false;
        }
    }
    return isValidate;
}
